/**
 * @author: dwi.setiyadi@gmail.com
*/

/*
Startup Examples:

import { ReducerSome } from '../modules/auth/ReducerSome';
const reducers: object = {
  some: ReducerSome,
};
export default reducers;
*/

import { ReducerNowPlayingDashboard } from '../modules/dashboard/ReducerDashboard';
import { ReducerAuth, ReducerLoader } from '../modules/auth/redux';
import { ReducerSession } from '../modules/session/redux';

const reducers: object = {
  nowPlaying: ReducerNowPlayingDashboard,
  auth: ReducerAuth,
  loader: ReducerLoader,
  session: ReducerSession
};

export default reducers;
